<template>
  <!-- eslint-disable -->
  <label v-bind:style="{color: color}" class="ratio">
    <strong class="ratio__label">Ratio</strong>
    <input
      class="ratio__range"
      type="range"
      v-bind:value="ratio"
      v-on:input="updateValue($event)"
      increment="0.01"
      min="0"
      max="1"
      step="0.001"
    >
  </label>
</template>

<script>
/*eslint-disable */
export default {
  name: 'Ratio',
  props: {
    ratio: Number,
    color: String
  },
  methods: {
    updateValue: function(event) {
      this.$emit('input', event.target.value);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const $range = document.querySelector('.ratio__range');
      function stop(e) {
        e.stopPropagation();
      }
      $range.addEventListener('mousedown', stop, false);
      $range.addEventListener('touchstart', stop, false);
      $range.addEventListener('mouseup', stop, false);
      $range.addEventListener('touchend', stop, false);
    });
  }
};
</script>

